import React from 'react'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'

function TitoloComponente({ index, componente, cambiaTitolo, lingua }) {
  return (
    <Box sx={{ p: 1, pt: 2, pl: 0 }}>
      <Stack direction="row" spacing={0} paddingBottom={1}>
        <TextField
          key={`titolo-${lingua}-${componente?.id || index}`}
          id="outlined-basic"
          variant="outlined"
          onChange={(event) => cambiaTitolo(index, lingua, event.target.value)}
          value={
            lingua == 1
              ? componente.titolo_italiano
              : lingua == 2
              ? componente.titolo_inglese
              : lingua == 3
              ? componente.titolo_tedesco
              : lingua == 4
              ? componente.titolo_olandese
              : lingua == 5
              ? componente.titolo_danese
              : lingua == 6
              ? componente.titolo_polacco
              : ''
          }
          size={'small'}
          fullWidth
          autoComplete="off"
        />
      </Stack>
    </Box>
  )
}

export default TitoloComponente
